
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';
import { type Gift, type Brand } from '@/utils/types';

interface ConsumeActionProps {
  selectedGift: Gift;
  brands: Brand[];
  onShowQRCode: () => void;
}

const ConsumeAction: React.FC<ConsumeActionProps> = ({
  selectedGift,
  brands,
  onShowQRCode
}) => {
  const getBrandName = (brandId: string) => {
    const brand = brands.find(b => b.id === brandId);
    return brand ? brand.name : 'Unknown';
  };

  const handleUseNow = () => {
    console.log("Use Now button clicked in ConsumeAction");
    onShowQRCode();
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Use your GivGo Bucks at the store or online.
      </p>
      <Card className="border-2 border-green-200 bg-green-50">
        <CardContent className="pt-6">
          <div className="text-center">
            <ShoppingCart className="h-10 w-10 mx-auto text-green-600 mb-2" />
            <p className="font-semibold">Ready to use!</p>
            <p className="text-muted-foreground text-sm">
              ${selectedGift.amount} GivGo Bucks at {getBrandName(selectedGift.brandId)}
            </p>
            <Button 
              className="mt-4 bg-givgo-purple hover:bg-givgo-purple/90"
              onClick={handleUseNow}
            >
              Use Now
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ConsumeAction;
